import { RootStoreModel } from "@redux/reducers";
import {
  Avatar,
  Col,
  Divider,
  List,
  Progress,
  Row
} from "antd";
import React from "react";
import { connect } from "react-redux";
import { NavLink, RouteComponentProps } from "react-router-dom";
// 引入 ECharts 主模块
import * as echarts from 'echarts';
import { getOverview, getPlatformLog } from "../../axios/api.account";

import { Translation } from "react-i18next";

// // 引入柱状图
import { InfoCircleOutlined } from '@ant-design/icons';
import { PieChart } from 'echarts/charts';
import { GridComponent } from 'echarts/components';
import 'echarts/lib/chart/bar';
import 'echarts/lib/chart/line';
import 'echarts/lib/component/legend';
import 'echarts/lib/component/markLine';
import 'echarts/lib/component/markPoint';
import 'echarts/lib/component/title';
import 'echarts/lib/component/toolbox';
import 'echarts/lib/component/tooltip';
import dayjs from 'dayjs';
interface propsModel extends RouteComponentProps<any, any, any> {
  account: any,
  isLogin: boolean
}
interface stateModel {
  deviceTypeStatistics: any[],
  enrollDeviceStatistics: {
    datas: any[],
    names: any[]
  },
  platformStatistics: any[],
  appStatistics: any[],
  operationLogs: any[],
  overviewInfo: any,
  isRegis: boolean,
  formatDate: string,
  deltaTime: number,
}

const mapStatetoProps = (state: RootStoreModel) => ({
  account: state.userState.account,
  isLogin: state.userState.tokenSuccess
});

class Overview extends React.Component<propsModel, stateModel> {

  constructor(props: propsModel) {
    super(props);
    this.state = {
      deviceTypeStatistics: [],
      enrollDeviceStatistics: {
        datas: [],
        names: []
      },
      platformStatistics: [],
      appStatistics: [],
      overviewInfo: {},
      operationLogs: [],
      isRegis: false,
      formatDate: "YYYY/MM/DD",
      deltaTime: 86400000*7,
    };

  }

  getInfo = () => {

    getOverview().then(async (res) => {

      res?.deviceTypeStatistics?.forEach((ele: any) => {
        this.state.deviceTypeStatistics.push({ value: ele?.count, name: ele?.deviceType })
      });
      res?.enrollDeviceStatistics?.forEach((ele: any, i: number) => {
        this.state.enrollDeviceStatistics.datas.push(ele?.count)
        this.state.enrollDeviceStatistics.names.push(ele?.enrollDate)
      });
      res?.platformStatistics?.forEach((ele: any) => {
        this.state.platformStatistics.push({ value: ele?.count, name: ele?.platform === "IOS" ? "iOS" : ele?.platform })
      });
      res?.appStatistics?.forEach((ele: any) => {
        this.state.appStatistics.push({ value: ele?.count, name: ele?.appType === "IOS" ? "iOS" : ele?.appType })
      });
      this.setState({
        deviceTypeStatistics: this.state.deviceTypeStatistics,
        enrollDeviceStatistics: this.state.enrollDeviceStatistics,
        platformStatistics: this.state.platformStatistics,
        appStatistics: this.state.appStatistics,
        // operationLogs: res?.operationLogs,
        overviewInfo: res
      });
      var paramsData = {
          TimeStart: dayjs(new Date().getTime()-this.state.deltaTime).format(this.state.formatDate),
          TimeEnd: dayjs(new Date().getTime()+86400000*1).format(this.state.formatDate),
          PageIndex: 1, 
          PageSize: 30
      };
      await getPlatformLog(paramsData).then(res => { this.setState({operationLogs: res.dataList}) });
      this.updateTable();
    });
    // } else {

    //   var that = this;
    //   var timer = setInterval(function () {
    //     that.getInfo();
    //     clearInterval(timer);
    //   }, 500);
    // }

  }
  updateTable = (titleMap: any={}) => {
    
    if (Object.keys(titleMap).length > 0) {
      localStorage.setItem("titleMap", JSON.stringify(titleMap));
    }
    var titles: any = localStorage.getItem("titleMap");
    if (titles) {
      titles = JSON.parse(titles);
    }
    
    let ec = echarts as any;
    ec?.use([PieChart, GridComponent]);
    // 初始化
    if (document.getElementById('deviceType')) {
      var deviceType = echarts.init(document.getElementById('deviceType') as HTMLDivElement);
      var deviceTypeArr = [];
      deviceType.setOption({
        title: {
          text: titleMap.deviceTypeTitle || titles.deviceTypeTitle || '设备类型',
          left: '55px',
          top: '15px'
        },
        tooltip: {
          trigger: 'item'
        },
        legend: {
          // left: 'left',
          // bottom: "10%"
          right: 'right',
          top: 'middle',
        },
        series: [
          {
            name: titleMap.deviceTypeTitle || titles.deviceTypeTitle || '设备类型',
            type: 'pie',
            radius: ['30%', '50%'],
            avoidLabelOverlap: false,
            data: this.state.platformStatistics,
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: 'rgba(0, 0, 0, 0.5)'
              }
            }
          }
        ]
      })
    }

    if (document.getElementById('nanotubesStatistics')) {
      var nanotubesStatistics = echarts.init(document.getElementById('nanotubesStatistics') as HTMLDivElement);
      nanotubesStatistics.setOption({
        title: {
          text: titleMap.registrationStatisticsTitle || titles.registrationStatisticsTitle || '注册统计',
          left: '55px',
          top: '15px'
        },
        xAxis: {
          type: 'category',
          data: this.state.enrollDeviceStatistics.names
        },
        yAxis: {
          type: 'value'
        },
        series: [{
          data: this.state.enrollDeviceStatistics.datas,
          type: 'line'
        }]
      })
    }

    if (document.getElementById('platformSummary')) {
      var platformSummary = echarts.init(document.getElementById('platformSummary') as HTMLDivElement);
      platformSummary.setOption({
        title: {
          text: titleMap.platformSummaryTitle || titles.platformSummaryTitle || '平台汇总',
          left: '55px',
          top: '15px'
        },
        tooltip: {
          trigger: 'item'
        },
        legend: {
          // left: 'left',
          // bottom: "10%"
          right: 'right',
          top: 'middle',
        },
        series: [
          {
            name: titleMap.platformSummaryTitle || titles.platformSummaryTitle || '平台汇总',
            type: 'pie',
            radius: ['30%', '50%'],
            data: this.state.deviceTypeStatistics,
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: 'rgba(0, 0, 0, 0.5)'
              }
            }
          }
        ]
      })
    }

    if (document.getElementById('applicationOverview')) {
      var applicationOverview = echarts.init(document.getElementById('applicationOverview') as HTMLDivElement);
      applicationOverview.setOption({
        title: {
          text: titleMap.applicationOverviewTitle || titles.applicationOverviewTitle || '应用概览',
          left: '55px',
          top: '15px'
        },
        tooltip: {
          trigger: 'item'
        },
        legend: {
          // left: 'left',
          // bottom: "10%"
          right: 'right',
          top: 'middle',
        },
        series: [
          {
            name: titleMap.applicationOverviewTitle || titles.applicationOverviewTitle || '应用概览',
            type: 'pie',
            radius: '50%',
            data: this.state.appStatistics,
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: 'rgba(0, 0, 0, 0.5)',
              }
            }
          }
        ]
      })
    }
    window.onresize = () => {
      deviceType?.resize();
      nanotubesStatistics?.resize();
      platformSummary?.resize();
      applicationOverview?.resize();
    }
  }

  componentDidMount() {
    if (this.props.isLogin) {
      this.getInfo();
    }

  }
  componentDidUpdate(prevProps: propsModel) {
    if (this.props.isLogin != prevProps.isLogin) {
      this.getInfo();
    }
  }
  temFinishPercentage=(tem:any)=>{
    
    var totalCount = tem.completedCount+tem.failedCount+tem.pendingCount;
    if(totalCount==0){
      return 0;
    }
    const percentage = (tem.completedCount * 100) / totalCount;
    return Math.round(percentage * 10) / 10;
  }
  goTemplateDevie=(id:any)=>{
    this.props.history.push({
      pathname: `/home/profiles/devices/${id}`, 
      state: {id:id}
    });
  }
  getProgressWidth=()=>{
    var templateTopborderBox:any = document.getElementById("TemplateTopborderBox")
    var divWidth = templateTopborderBox.offsetWidth;
    var w = divWidth/5 -32-32;
    console.log("homeTemplateBox",templateTopborderBox.offsetWidth,w)
    return w;
  }
  render() {
    const {
      overviewInfo,
      operationLogs,
    } = this.state;
    const { isLogin } = this.props;
    return (
      <div className="overviewBox" >
        {isLogin && (
          <Translation>
            {t => {
              var titleMap = {
                deviceTypeTitle: t("设备类型"),
                registrationStatisticsTitle: t("注册统计"),
                platformSummaryTitle: t("平台汇总"),
                applicationOverviewTitle: t("应用概览"),
              }
              this.updateTable(titleMap);
              
              return (
                <Row justify="center">
                  <Row className="TopborderBox" gutter={[16, 16]}>
                    <Col className="TopborderBoxCol">
                      <div>
                        <p className="homeNumberTitle" style={{marginBottom: "12px"}}>{t("注册设备")}<InfoCircleOutlined className="homeNumberInfo" /></p>
                        <div>
                          <Avatar src={"/images/summaryIcon1.png"} style={{width: "50px",height: "50px",padding: "15px",backgroundColor: "#D7E6FE",margin: "-22px 12px 0 0"}}/>
                          <span className="homeNumber" style={{ color: "#1890FF" }}>{overviewInfo.enrollDeviceCount}</span>
                        </div>
                        <Divider style={{
                          height: "5px",
                          borderRadius: "5px",
                          backgroundColor: "#1890FF",
                          margin: "14px 0",
                        }} />
                      </div>
                    </Col>
                    <Col className="TopborderBoxCol">
                      <div>
                        <p className="homeNumberTitle"  style={{marginBottom: "12px"}}>{t("活跃设备")}<InfoCircleOutlined className="homeNumberInfo" /></p>
                        <div>
                          <Avatar src={"/images/summaryIcon2.png"} style={{width: "50px",height: "50px",padding: "15px",backgroundColor: "#FBE6E3",margin: "-22px 12px 0 0"}}/>
                          <span className="homeNumber" style={{color: "#ED603C"}}>{overviewInfo.activceDeviceCount}</span>
                        </div>
                        <Divider style={{
                          height: "5px",
                          borderRadius: "5px",
                          backgroundColor: "#ED603C",
                          margin: "14px 0",
                        }} />
                      </div>
                    </Col>
                    <Col className="TopborderBoxCol">
                      <div>
                        <p className="homeNumberTitle"  style={{marginBottom: "12px"}}>{t("注册中设备")}<InfoCircleOutlined className="homeNumberInfo" /></p>
                        <div>
                          <Avatar src={"/images/summaryIcon3.png"} style={{width: "50px",height: "50px",padding: "15px",backgroundColor: "#D8F6F8",margin: "-22px 12px 0 0"}}/>
                          <span className="homeNumber" style={{color: "#31CFC9"}}>{overviewInfo.enrollingDeviceCount}</span>
                        </div>
                        <Divider style={{
                          height: "5px",
                          borderRadius: "5px",
                          backgroundColor: "#31CFC9",
                          margin: "14px 0",
                        }} />
                      </div>
                    </Col>
                    <Col className="TopborderBoxCol">
                      <div>
                        <p className="homeNumberTitle"  style={{marginBottom: "12px"}}>{t("用户")}<InfoCircleOutlined className="homeNumberInfo" /></p>
                        <div>
                          <Avatar src={"/images/summaryIcon4.png"} style={{width: "50px",height: "50px",padding: "15px",backgroundColor: "#FCF4E0",margin: "-22px 12px 0 0"}}/>
                          <span className="homeNumber" style={{color: "#F5AD5F"}}>{overviewInfo.userCount}</span>
                        </div>
                        <Divider style={{
                          height: "5px",
                          borderRadius: "5px",
                          backgroundColor: "#F5AD5F",
                          margin: "14px 0",
                        }} />
                      </div>
                    </Col>
                    <Col className="TopborderBoxCol">
                      <div>
                        <p className="homeNumberTitle"  style={{marginBottom: "12px"}}>{t("企业应用")}<InfoCircleOutlined className="homeNumberInfo" /></p>
                        <div>
                          <Avatar src={"/images/summaryIcon5.png"} style={{width: "50px",height: "50px",padding: "15px",backgroundColor: "#D4E7FD",margin: "-22px 12px 0 0"}}/>
                          <span className="homeNumber" style={{color: "#5E9DFF"}}>{overviewInfo.appCount}</span>
                        </div>
                        <Divider style={{
                          height: "5px",
                          borderRadius: "5px",
                          backgroundColor: "#5E9DFF",
                          margin: "14px 0",
                        }} />
                      </div>
                    </Col>
                  </Row>       
                  <Row className="marginBox">
                    <Col span={18}>
                      <Row gutter={[16, 16]} >
                        <Col span={12}>
                          <img src="/images/overview_icon1.svg" alt="" style={{
                            position: 'absolute', zIndex: 1, marginLeft: 35, marginTop: 22
                          }}/>
                          <div id="deviceType" className="homeContentTableBox"></div>
                        </Col>
                        <Col span={12}>
                          <img src="/images/overview_icon2.svg" alt="" style={{
                            position: 'absolute', zIndex: 1, marginLeft: 35, marginTop: 22
                          }}/>
                          <div id="nanotubesStatistics" className="homeContentTableBox"></div>
                        </Col>
                        <Col span={12}>
                          <img src="/images/overview_icon4.svg" alt="" style={{
                            position: 'absolute', zIndex: 1, marginLeft: 35, marginTop: 22
                          }}/>
                          <div id="platformSummary" className="homeContentTableBox"></div>
                        </Col>
                        <Col span={12}>
                          <img src="/images/overview_icon5.svg" alt="" style={{
                            position: 'absolute', zIndex: 1, marginLeft: 35, marginTop: 22
                          }}/>
                          <div id="applicationOverview" className="homeContentTableBox"></div>
                        </Col>
                      </Row>
                    </Col>
                    <Col span={6}>
                      <div className="homeContentLogBox">
                        <div style={{display: "flex", justifyContent: "space-between"}}>
                          <div style={{marginLeft: "2px", marginTop: "12px", fontWeight: 800, display: "flex", }}>
                            <img src="/images/overview_icon3.svg" alt="" />
                            <span style={{marginLeft: "8px", marginTop: "2px", width: "-webkit-fill-available"}}>{t("日志")}</span>
                          </div>
                          <NavLink to="/home/reports/logs" style={{marginTop: "14px"}}>{t("更多")}</NavLink>
                        </div>
                        <List
                          // bordered
                          itemLayout="horizontal"
                          style={{marginTop: "9px", height: "605px", overflowY: "auto", padding: "0 10px"}}
                          dataSource={operationLogs}
                          renderItem={item => (
                            <List.Item>
                              <List.Item.Meta
                                // avatar={
                                //   (item.platform === "IOS" && <Avatar src={"/images/iPhoneIcon.png"} />) || 
                                //   (item.platform === "macOS" && <Avatar src={"/images/macIcon.png"} />) ||
                                //   (item.platform === "Android" && <Avatar src={"/images/androidIcon.png"} />)
                                // }
                                title={<p>{`【${item.operator ? item.operator.split("@")[0] : item.operator}】${item.content}`}</p>}
                                description={item.operationTime}
                              />
                            </List.Item>
                          )}
                          />
                      </div>


                      {/* <div className="homeContentLogBox">
                        {operationLogs.map(
                          (
                            {
                              platform,
                              operationType,
                              content,
                              operationTime,
                              id
                            },
                            i
                            ) => (
                            <Row key={id}>
                              <Col span={24} className="operationContent">{content}</Col>
                              <Col span={10} className="operationTime">{operationTime}</Col>
                              </Row>
                              ))}
                            </div> */}
                    </Col>
                  </Row>
                  <Row className="TopborderBox" gutter={[16, 16]} id="TemplateTopborderBox">
                    {overviewInfo?.templateApplyStatistics?.map((tem:any)=>(
                      <Col className="BottomTemplateBoxCol" onClick={()=>{this.goTemplateDevie(tem.templateId)}}>
                      <div className="homeTemplateBox">
                        <p className="homeTemplateTitle" style={{marginBottom: "12px"}}>{tem.templateName}</p>
                        <Divider />
        
                        <Progress type="circle" strokeColor={"#31CDC9"} width={this.getProgressWidth()} strokeWidth={15} percent={this.temFinishPercentage(tem)} format={percent =>(<><p style={{fontSize:26,fontWeight:500,lineHeight:"32px",marginBottom:4,marginTop:18,color:"#666666"}}> {percent+"%"}</p>
                          <p style={{fontSize:26,fontWeight:500,lineHeight:"26px",color:"#666666"}}>{t("成功")}</p></>)} />
                        <div>
                          <div className="templatePointerBox">
                            <div className="templatePointerSuccess"></div>
                          </div>
                          <span className="templateNumber">{tem.completedCount} {t("Completed")}</span>           
                        </div>
                        <div>
                          <div className="templatePointerBox">
                            <div className="templatePointerPadding"></div>
                          </div>
                          <span className="templateNumber">{tem.pendingCount} {t("Pending")}</span>           
                        </div>
                        <div>
                          <div className="templatePointerBox">
                            <div className="templatePointerErr"></div>
                          </div>
                          <span className="templateNumber">{tem.failedCount} {t("Failed")}</span>           
                        </div>
                        
                      </div>
                    </Col>
                    ))}
                    
                   
            
                  </Row>       
                </Row>
              )
            }}
          </Translation>
        )}
      </div>

    )
  }
}
export default connect(mapStatetoProps, {})(Overview);
